import script from "./PaymentModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaymentModal.vue?vue&type=script&lang=ts&setup=true"

import "./PaymentModal.vue?vue&type=style&index=0&id=a4c7bae8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4c7bae8"]])

export default __exports__